import React from "react";

import CustomOptionRadio from "./CustomOptionRadio";
import CustomOptionText from "./CustomOptionText";
import CustomOptionTextarea from "./CustomOptionTextarea";

const CustomOption = ({ option, selectedOption }) => {
  if (option.type === "radio") {
    return (
      <CustomOptionRadio
        {...option}
        key={option.option_id}
        required={option.is_required}
        selectedOption={selectedOption}
      />
    );
  } else if (option.type === "field") {
    return (
      <CustomOptionText
        {...option}
        key={option.option_id}
        required={option.is_required}
        selectedOption={selectedOption}
      />
    );
  } else if (option.type === "area") {
    return (
      <CustomOptionTextarea
        {...option}
        key={option.option_id}
        required={option.is_required}
        selectedOption={selectedOption}
      />
    );
  } else {
    console.warn(
      `The "${option.type}" custom option type is not supported yet.`
    );
    if (option.required) {
      throw new Error("This product can't be ordered yet.");
    }
    return null;
  }
};

export default CustomOption;
